import { FormGroup } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import { Control, FieldError, FieldValues, Path, RegisterOptions, useController } from 'react-hook-form';

export type FormCheckboxProps<T extends FieldValues> = {
    label: string;
    name: Path<T>;
    control: Control<T>;
    rules?: Omit<RegisterOptions<T>, 'valueAsNumber' | 'valueAsDate' | 'setValueAs'>;
    required?: boolean;
    fieldError?: FieldError;
};

export function FormCheckbox<T extends FieldValues>({ label, name, control, rules = {}, fieldError }: FormCheckboxProps<T> ) {
    const {  field: { value, ref, ...inputProps }, } = useController({
        name,
        control,
        rules,
    });

    return (
        <>
            <FormGroup>
                <FormControlLabel 
                    control={ <Checkbox {...inputProps} checked={Boolean(value)} inputRef={ref} /> }
                    label={label + (!!rules.required ? ' *' : '')} 
                />
            </FormGroup>
            {!!fieldError && <FormHelperText>{fieldError?.message}</FormHelperText>}
        </>
    );
}
